import React from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setCurrency } from '@/redux/actions/currencyActions';
import { setLenguageData } from '@/redux/actions/lenguageDataActions';
import { Link } from 'react-router-dom';

export const NewHeaderModal = (props) => {
  const { isOpen, onClose, languageData } = props;
  const userData = useSelector((state) => state.user);
  const lenguageData = useSelector((state) => state.lenguage.lang);
  const currencyData = useSelector((state) => state.currency.currency);
  const dispatch = useDispatch();

  const changueLang = () => {
    dispatch(
      setLenguageData({
        lang: lenguageData === 'EN' ? 'ES' : 'EN',
        isButton: true,
      }),
    );
  };

  const changueCurrency = () => {
    dispatch(
      setCurrency({
        currency: currencyData === 'USD' ? 'MXN' : 'USD',
        isButton: true,
      }),
    );
  };

  const closeSession = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('auth_data');
    localStorage.removeItem('access_token');
    window.location.href = '/';
  };

  if (!isOpen) return null;

  return (
    <FlexContainer
      className={'pos-fixed top0 left0 right0 bottom0 bgTransparentWhite'}
      style={{
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <FlexContainer
        className={'flex-column bgGradientSignUpPurple0'}
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '75%',
          maxWidth: '320px',
          minWidth: '260px',
          color: 'white',
          paddingBottom: '24px',
          boxShadow: '2px 0 8px rgba(0,0,0,0.25)',
          position: 'relative',
          opacity: 0.9,
        }}
      >
        <FlexContainer
          className={'align-items-center pad16'}
          style={{
            position: 'absolute',
            top: '10px',
            cursor: 'pointer',
          }}
          onClick={onClose}
        >
          <i className="fa fa-chevron-left"></i>
        </FlexContainer>
        <FlexContainer className="flex-column padlr30  margt80 margb10">
          <Link
            to="/"
            onClick={onClose}
            className={`width100 text-left justify-start fontWhite padtb10 text-24 text-primary visited:text-primary cursor-pointer decoration-none  ${
              userData ? 'padb0' : ''
            }`}
          >
            {languageData === 'EN' ? 'Home ' : 'Inicio '}
          </Link>
        </FlexContainer>
        <FlexContainer className="flex-column padlr30 ">
          {!userData ? (
            <>
              <Link
                to={languageData === 'EN' ? '/signup' : '/registrarse'}
                onClick={onClose}
                className="'width100 text-left justify-start fontGray050 padtb10 text-16 text-primary visited:text-primary cursor-pointer decoration-none"
              >
                {languageData === 'EN' ? 'Signup' : 'Registrarse'}
              </Link>
              <Link
                to={languageData === 'EN' ? '/login' : '/iniciar-sesion'}
                onClick={onClose}
                className="'width100 text-left justify-start fontGray050 padtb10 text-16 text-primary visited:text-primary cursor-pointer decoration-none"
              >
                {languageData === 'EN' ? 'Login ' : 'Iniciar Sesión '}
              </Link>

              <Link
                to={languageData === 'EN' ? '/stillBuilding' : '/aun-construyendo'}
                onClick={onClose}
                className="'width100 text-left justify-start fontGray050 padt60 text-16 text-primary visited:text-primary cursor-pointer decoration-none"
              >
                {languageData === 'EN' ? 'Popular Coworkings' : 'Coworkings Populares'}
              </Link>
            </>
          ) : (
            <>
              {[
                languageData === 'EN' ? 'My Profile' : ' Mi Perfil',
                languageData === 'EN' ? 'My Bookings' : 'Mis Reservas',
                languageData === 'EN' ? 'Saved Spaces' : 'Espacios Guardados',
                languageData === 'EN' ? 'Payment / Billing' : 'Pagos / Facturación',
              ].map((text, index) => (
                <Link
                  key={index}
                  to={languageData === 'EN' ? '/stillBuilding' : '/aun-construyendo'}
                  onClick={onClose}
                  className="'width100 text-left justify-start fontGray050 padtb10 text-16 text-primary visited:text-primary cursor-pointer decoration-none"
                >
                  {text}
                </Link>
              ))}
              <Link
                to={languageData === 'EN' ? '/payment-card-selector' : '/payment-card-selector'}
                onClick={onClose}
                className="'width100 text-left justify-start fontGray050 padtb10 text-16 text-primary visited:text-primary cursor-pointer decoration-none"
              >
                {languageData === 'EN' ? 'Payment Methods' : 'Métodos de Pago'}
              </Link>
            </>
          )}
        </FlexContainer>
        {userData && (
          <FlexContainer className="flex-column padlr30 margt40 border-top-grey">
            <Link
              to={languageData === 'EN' ? '/stillBuilding' : '/aun-construyendo'}
              onClick={onClose}
              className="'width100 text-left justify-start fontGray050 padt0 text-16 text-primary visited:text-primary cursor-pointer decoration-none"
            >
              {languageData === 'EN' ? 'Popular Coworkings' : 'Coworkings Populares'}
            </Link>
          </FlexContainer>
        )}
        <FlexContainer className="flex-column padlr30 margt20">
          <Button
            className={'width100 text-left justify-start fontGray050 padtb10'}
            onClick={changueLang}
            startIcon={
              <i
                className="fas fa-globe"
                style={{
                  color: 'white',
                  fontSize: '18px',
                  marginRight: '6px',
                  transform: 'translateY(1px)',
                }}
              ></i>
            }
            sx={{
              color: 'white',
              textTransform: 'none',
              justifyContent: 'flex-start',
              alignItems: 'center',
              fontSize: '17px',
              fontWeight: 200,
            }}
          >
            {languageData === 'EN' ? 'English' : 'Español'}
          </Button>

          <Button
            className={'width100 text-left justify-start fontGray050 padtb10'}
            onClick={changueCurrency}
            startIcon={
              <i
                className="fas fa-dollar-sign"
                style={{
                  color: 'white',
                  fontSize: '18px',
                  marginRight: '12px',
                  transform: 'translateY(1px)',
                }}
              ></i>
            }
            sx={{
              color: 'white',
              textTransform: 'none',
              justifyContent: 'flex-start',
              alignItems: 'center',
              fontSize: '17px',
              fontWeight: 200,
            }}
          >
            {languageData === 'EN'
              ? 'Currency (' + currencyData + ')'
              : 'Moneda (' + currencyData + ')'}
          </Button>
        </FlexContainer>
        <FlexContainer
          className="flex-column padlr30 margb30"
          style={{
            marginTop: 'auto',
          }}
        >
          <Link
            to={languageData === 'EN' ? '/privacy-policy' : '/politica-privacidad'}
            onClick={onClose}
            className={`width100 text-left justify-start fontGray050 padt40  text-16 text-primary visited:text-primary cursor-pointer decoration-none ${
              userData ? '' : 'padb10'
            } `}
          >
            {languageData === 'EN' ? 'Privacy Policy' : 'Política de Privacidad'}
          </Link>
          <Link
            to={languageData === 'EN' ? '/terms-conditions' : '/terminos-condiciones'}
            onClick={onClose}
            className={`width100 text-left justify-start fontGray050 padtb20 text-16 text-primary visited:text-primary cursor-pointer decoration-none`}
          >
            {languageData === 'EN' ? 'Terms of Service' : 'Términos y Condiciones'}
          </Link>
          {userData ? (
            <>
              <Link
                to={languageData === 'EN' ? '/stillBuilding' : '/aun-construyendo'}
                onClick={onClose}
                className="'width100 text-left justify-start fontGray050 padb10 text-16 text-primary visited:text-primary cursor-pointer decoration-none"
              >
                {languageData === 'EN' ? 'Help / FAQ' : 'Ayuda / Preguntas Frecuentes'}
              </Link>
              <FlexContainer
                className={`width100 text-left justify-start fontGray050  ${
                  userData ? 'padtb10' : 'padtb10'
                }`}
                onClick={closeSession}
                sx={{
                  textTransform: 'none',
                  justifyContent: 'flex-start',
                  fontSize: '18px',
                }}
              >
                {languageData === 'EN' ? 'Log Out' : 'Cerrar sesión'}
              </FlexContainer>
            </>
          ) : (
            [languageData === 'EN' ? 'Help / FAQ' : 'Ayuda / Preguntas Frecuentes'].map(
              (text, index) => (
                <Link
                  key={index}
                  to={languageData === 'EN' ? '/stillBuilding' : '/aun-construyendo'}
                  onClick={onClose}
                  className="'width100 text-left justify-start fontGray050 padtb10 text-16 text-primary visited:text-primary cursor-pointer decoration-none"
                >
                  {text}
                </Link>
              ),
            )
          )}
        </FlexContainer>{' '}
      </FlexContainer>
    </FlexContainer>
  );
};

export default NewHeaderModal;
